import request from '../utils/request';

export interface SettingsDto {
    id: string;
    code: string;
    description: string;
    value: string | boolean | number;
    type: string;
}

export function initSettings(): SettingsDto {
    return {
        id: '',
        code: '',
        description: '',
        value: '',
        type: '',
    };
}

export enum SettingsType {
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    BOOLEAN = 'BOOLEAN',
    HTML = 'HTML',
}

export function fetchHtml(type: string): Promise<string> {
    return request(`/settings/${type}`).then(({ data }) => data.value as string);
}
